const ContactSection = {
  parts: [
    'container',
    'grid',
    'titleColumn',
    'infoColumn',
    'formColumn',
    'title',
    'infoStack',
    'contactItem',
    'icon',
    'link',
    'text',
    'description',
    'form',
    'formStack',
    'input',
    'textarea',
    'submitButton',
  ],
  baseStyle: {
    container: {
      padding: {base: '40px 0 0', lg: '87px 0 0 0'},
    },
    grid: {
      gap: {base: '24px', lg: '40px'},
      templateColumns: {base: '1fr', lg: '290px 1fr 1fr'},
    },
    titleColumn: {},
    infoColumn: {},
    formColumn: {},
    title: {
      fontSize: {base: '28px', lg: '40px'},
      fontWeight: '500',
    },
    infoStack: {
      align: 'stretch',
      color: 'brandColors.greyscale90',
      fontSize: '16px',
      lineHeight: '160%',
      spacing: 3,
      breakWords: true,
      wordBreak: 'break-all',
    },
    contactItem: {
      spacing: 3,
    },
    icon: {
      boxSize: 5,
      color: 'brandColors.primaryDarkLinen',
      flexShrink: 0,
    },
    link: {
      color: 'brandColors.greyscale90',
      fontSize: '16px',
      lineHeight: '160%',
    },
    text: {
      color: 'brandColors.greyscale90',
      fontSize: '16px',
      lineHeight: '160%',
    },
    description: {
      wordBreak: 'break-word',
      color: 'brandColors.greyscale90',
      fontSize: '16px',
      lineHeight: '160%',
      mt: '12px',
    },
    form: {},
    formStack: {
      spacing: '13px',
    },
    input: {
      bg: 'white',
      borderColor: 'brandColors.greyscale10',
      color: 'brandColors.greyscale80',
      size: 'md',
    },
    textarea: {
      bg: 'white',
      borderColor: 'brandColors.greyscale10',
      color: 'brandColors.greyscale80',
      minH: '100px',
      resize: 'vertical',
      size: 'md',
    },
    submitButton: {
      _hover: {bg: 'gray.800'},
      fontSize: '14px',
      fontWeight: '600',
      padding: '14px 48px',
      lineHeight: 1.2,
      height: 'auto',
      minHeight: '54px',
      w: 'full',
    },
  },
};

export default ContactSection;
